<div class="qr-page">

  <wr-qr-code-building-header active="maintenance" [showSections]="true"></wr-qr-code-building-header>

  <wr-search-bar
    [(search)]="searchText"
    (searchChange)="searchTextChange($event)">
  </wr-search-bar>

  <div class="timer-list">
    @for (timer of filteredMaintenanceTimers(); track timer.id) {
    <div class="timer-card"
         data-cy="qr-maintenance-timer"
         [class.timer-card--overdue]="daysLeft(timer) < 0"
         [class.timer-card--soon]="daysLeft(timer) >= 0 && daysLeft(timer) <= 7"
         [class.timer-card--ok]="daysLeft(timer) > 7">

      <div class="timer-top">
        <div class="days-indicator">
          <span class="days-num">{{ daysLeft(timer) }}</span>
          <span class="days-unit">{{ daysLeft(timer) | pluralize: 'Tag' : 'Tage' }}</span>
        </div>
        <span class="timer-type-label">{{ timer.type | maintenanceTimerType }}</span>
      </div>

      <div class="equipment-row">
        <span class="equipment-qty">{{ timer.buildingEquipmentQuantity }}&thinsp;×</span>
        <span class="equipment-name">{{ timer.buildingEquipmentName }}</span>
      </div>

      <div class="timer-meta">
        <div class="timer-meta-row">
          <span class="timer-meta-label">Dauer</span>
          <span class="timer-meta-value">
            {{ timer.durationDays }} {{ timer.durationDays | pluralize: 'Tag' : 'Tage' }}
          </span>
        </div>

        <div class="timer-meta-row">
          <span class="timer-meta-label">Nächste {{ timer.type | maintenanceTimerType }}</span>
          <span class="timer-meta-value">
            <nb-icon icon="calendar-outline" pack="eva"></nb-icon>
            {{ timer.nextDate | date:'dd.MM.yyyy' }}
          </span>
        </div>

        <div class="timer-meta-row">
          <span class="timer-meta-label">Erinnerung</span>
          <span class="timer-meta-value">{{ timer.reminderDate | date:'dd.MM.yyyy' }}</span>
        </div>

        <div class="timer-meta-row">
          <span class="timer-meta-label">Wiederholungen</span>
          <span class="timer-meta-value">{{ timer.iterations }}</span>
        </div>
      </div>

      @if (timer.canFinish) {
        <button class="finish-btn" nbButton size="small"
                data-cy="qr-timer-finish"
                [status]="timer.isAllowedToFinish ? 'primary' : 'basic'"
                (click)="finishMaintenanceTimer(timer)"
                [disabled]="!timer.isAllowedToFinish">
          <nb-icon icon="checkmark-outline" pack="eva"></nb-icon>
          Erledigen
        </button>
      }
    </div>
    } @empty {
    <div class="empty-state">
      <nb-icon icon="checkmark-circle-2-outline" pack="eva"></nb-icon>
      <p>Keine Wartungen gefunden</p>
    </div>
    }
  </div>

</div>
